/**** WARNING: This is a generated file, so any changes might get overwritten! ****/
const _t = (window as any).vvTranslations?.News || {};
export * from './Common.ts';
export const Page_Header = (): string => _t.Page_Header ?? "Blogs & News";
export const Error_Message = (): string => _t.Error_Message ?? "Failed to load";
export const Blogs_Tab = (): string => _t.Blogs_Tab ?? "Blogs";
export const News_Tab = (): string => _t.News_Tab ?? "Newsletters";
export const Empty_State_Title = (): string => _t.Empty_State_Title ?? "No Articles Yet";
export const Empty_State_Description = (): string => _t.Empty_State_Description ?? "Check back again soon for updates!";
export const Archive_Label = (): string => _t.Archive_Label ?? "Archive of";
export const Share_Label = (): string => _t.Share_Label ?? "Share via";
export const By_Label = (): string => _t.By_Label ?? "By";
